import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { logoutUser } from "actions/index";
import Button from "components/Common/Button";
import "./style.scss";
import classnames from "classnames";

// This modal is a bit different from other modals - it is displayed as a component directly in
// Root.jsx, rather than being a view that is set for the <Modal /> component. This allows it to
// be displayed on top of another modal.

const BLOCK_NAME = "SessionTimeoutModal";

/**
 * Returns Session Timeout Modal component
 * @param {Object} props
 * @returns {*}
 */
export function SessionTimeoutModal(props) {
  // Unfocus selected element (e.g. input field)
  document.activeElement.blur();

  const { isOpen, modalLogoutUser } = props;

  return (
    <div
      id="modal"
      className={
        classnames(
          "Modal",
          "Modal--small",
          {
            "Modal--active": isOpen
          }
        )
      }
    >
      <div className="Modal__mask" />
      <div
        className={
          classnames(
            "Modal__container",
            "Modal__container--small"
          )
        }
      >
        <div className="Modal__inner-container">
          <div className={`${BLOCK_NAME} Modal_modal`}>
            <h5 className="Modal__title Modal__title--small">Session Expired</h5>
            <div className="Modal__content Modal__content--no-top-padding">
              <section className="Modal__section SessionTimeoutModal__details">
                <p>
                  Your session has expired because you&apos;ve been inactive for more than 24 hours.
                </p>
              </section>
            </div>

            <div className={`${BLOCK_NAME}__bottom`}>
              <Button
                text="Log In"
                stretched
                lightPrimary
                onClick={modalLogoutUser}
                disabledStyleFlat
                customClassName={`${BLOCK_NAME}__button`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SessionTimeoutModal.propTypes = {
  modalLogoutUser: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapState(state) {
  const { modalSessionTimeout } = state;

  return {
    isOpen: modalSessionTimeout.get("isOpen")
  };
}

/**
 * @param {Function} dispatch
 * @returns {Object}
 */
function mapDispatch(dispatch) {
  return {
    modalLogoutUser: bindActionCreators(logoutUser, dispatch)
  };
}

const Connector = connect(
  mapState,
  mapDispatch
)(SessionTimeoutModal);

export default Connector;
